import api from './api';

export const hrService = {
  /**
   * Upload resignation letter and create approval request (NEW)
   * @param {File} file - Resignation letter file
   * @param {string} reason - Resignation reason
   * @returns {Promise} API response
   */
  uploadResignationLetter: async (file, reason) => {
    const formData = new FormData();
    formData.append('resignationLetter', file);
    formData.append('reason', reason);
    
    // Send FormData to backend - axios will auto-detect and set proper multipart headers
    const response = await api.post('/hr/resignation/upload', formData);
    return response.data;
  },

  /**
   * Get resignation request status (NEW)
   * @returns {Promise} API response
   */
  getResignationRequest: async () => {
    const response = await api.get('/hr/resignation/status');
    return response.data;
  },

  /**
   * Finalize resignation after admin approval (NEW)
   * @returns {Promise} API response
   */
  finalizeResignation: async () => {
    const response = await api.post('/hr/resignation/finalize');
    return response.data;
  },

  /**
   * Get all resignation requests pending approval (Admin only) (NEW)
   * @param {object} params - Query parameters (page, limit, status)
   * @returns {Promise} API response
   */
  getResignationRequests: async (params = {}) => {
    const response = await api.get('/hr/resignation/requests', { params });
    return response.data;
  },

  /**
   * Approve resignation (Admin only) (NEW)
   * @param {string} requestId - Resignation request ID
   * @param {object} data - { notes?: string }
   * @returns {Promise} API response
   */
  approveResignation: async (requestId, data = {}) => {
    const response = await api.patch(`/hr/resignation/requests/${requestId}/approve`, data);
    return response.data;
  },

  /**
   * Reject resignation (Admin only) (NEW)
   * @param {string} requestId - Resignation request ID
   * @param {object} data - { rejectionReason: string }
   * @returns {Promise} API response
   */
  rejectResignation: async (requestId, data) => {
    const response = await api.patch(`/hr/resignation/requests/${requestId}/reject`, data);
    return response.data;
  },

  /**
   * Submit resignation (DEPRECATED - use uploadResignationLetter instead)
   * @param {string} reason - Resignation reason
   * @returns {Promise} API response
   */
  submitResignation: async (reason) => {
    const response = await api.post('/hr/resign', { reason });
    return response.data;
  },

  /**
   * Get HR status
   * @returns {Promise} API response
   */
  getHRStatus: async () => {
    const response = await api.get('/hr/status');
    return response.data;
  },

  /**
   * Get resigned users (Admin/HRO only)
   * @param {object} params - Query parameters
   * @returns {Promise} API response
   */
  getResignedUsers: async (params = {}) => {
    const response = await api.get('/hr/resigned-users', { params });
    return response.data;
  }
};

export default hrService;